/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex } from '@radix-ui/themes';

import Text from 'solis/react/primitive/text';

import descriptor from 'solis/claude/action/descriptor/surrender.zone';
import ActionCard from 'solis/claude/action/card';

import UserName from 'solis/claude/element/user/name';

import ZoneInfluences from 'solis/logic/board/zone/influences';
import ZoneTimeline from 'solis/logic/board/zone/timeline';
import ZoneUsers from 'solis/logic/board/zone/users';


// The challenger appears only while the account still holds the zone — projecting who
// takes over makes no sense once the zone is already lost.
const makeLabel = ({ board, zone, account, now }) =>
{
  if (zone === null || !new ZoneUsers(zone).isCurrentUser(account.cass.id))
  {
    return 'Surrender zone';
  }

  const challenger = ZoneTimeline.createWithSurrender(zone, now).getWinner(now);

  if (challenger === account.cass.id)
  {
    return 'Surrender zone';
  }

  // The outer gap stays wider than the swatch-to-name gap inside UserName, so the
  // swatch groups with the name rather than with 'to'.
  return (
    <Flex as = 'span' display = 'inline-flex' align = 'center' gap = '3'>
      {'Surrender zone to'}
      <UserName board = {board} user = {challenger} size = '2' color = {null} />
    </Flex>
  );
};


const Outcome = ({ zone, account }) =>
{
  const influences = new ZoneInfluences(zone);

  const returned = influences.getUserInfluenceValue(account.cass.id);
  const granted = influences.getSurrenderCurrency();

  const grants = granted > 0 ? ', grants ' + granted + ' currency' : '';

  return <Text.Note>{'Returns ' + returned + ' influence' + grants}</Text.Note>;
};


// Children evaluate before ActionCard gates on availability, so they must tolerate a
// missing target zone.
export default ({ context }) =>
(
  <ActionCard label = {makeLabel(context)} descriptor = {descriptor} context = {context}>

    {context.zone !== null && <Outcome zone = {context.zone} account = {context.account} />}

  </ActionCard>
);
